import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminNav from './AdminNav';
import './AdminPanel.css';

const AdminPanel = ({ stats, fetchStats }) => {
  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div className="admin-panel">
      <AdminNav />

      <div className="admin-dashboard">
        <h2>Dashboard</h2>
        <div className="stats-grid">
          <div className="stat-card">
            <h3>Total Categories</h3>
            <p className="stat-number">{stats.categories}</p>
            <Link to="/admin/categories" className="stat-link">Manage Categories →</Link>
          </div>
          <div className="stat-card">
            <h3>Total Products</h3>
            <p className="stat-number">{stats.products}</p>
            <Link to="/admin/products" className="stat-link">Manage Products →</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
